import React, { useEffect } from 'react';
import ShowFinalScore from './ShowFinalScore';
import { useAptitudeTestScoreQuery } from '../AptitudeQuizSlice';
import Loading from 'components/global/layout/Loading';
import { useGetSummaryQuery } from 'components/dashboard/panel/panelSlice';

const AptitudeScoreCard = () => {
  const { isLoading, isSuccess, data } = useAptitudeTestScoreQuery();
  const { refetch } = useGetSummaryQuery({});
  const condition = Boolean(data);
  //Fetch summary so that user sees updated score after navigating to the home screen
  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <>
      {isLoading && <Loading />}
      {isSuccess && !condition && <div>No Score Found</div>}
      {isSuccess && condition && <ShowFinalScore data={data} />}
    </>
  );
};

export default AptitudeScoreCard;
